// redux store for data
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import { logger } from "redux-logger";
import createRootReducer from "./Reducers";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { composeWithDevTools } from "redux-devtools-extension";

export const history = createBrowserHistory();

const initialState = {};
let middleware = [thunk, logger];
// remove redux logger in production
if (process.env.NODE_ENV === "development") {
  middleware = [thunk, logger];
} else {
  middleware = [thunk];
}

// React 18: Updated store configuration with proper middleware composition
const store = createStore(
  createRootReducer(history),
  initialState,
  composeWithDevTools(
    applyMiddleware(...middleware, routerMiddleware(history))
  )
);

export default store;
